export function normalizeInternationalPhone(value) {
  const raw = String(value || "").trim();
  const digits = raw.replace(/\D/g, "");
  return raw.startsWith("+") ? `+${digits}` : digits;
}

const text = (value) => String(value ?? "").trim();
const commaList = (value) => text(value).split(",").map((item) => item.trim()).filter(Boolean);

export function normalizeApplicationPayload(form, { photo, signature }) {
  return {
    name: text(form.name),
    email: text(form.email),
    phone: normalizeInternationalPhone(form.phone),
    date_of_birth: form.date_of_birth,
    address: text(form.address),
    city: text(form.city),
    postal_code: text(form.postal_code),
    total_experience: Number(form.total_experience),
    skills: commaList(form.skills),
    languages: commaList(form.languages),
    education: form.education.map((row) => ({
      qualification: text(row.qualification),
      institution: text(row.institution),
      year: Number(row.year),
      grade: text(row.grade) || null,
    })),
    experience: form.experience.filter((row) => Object.values(row).some((value) => text(value))).map((row) => ({
      employer: text(row.employer),
      job_title: text(row.job_title),
      from_date: row.from_date,
      to_date: row.to_date || null,
      responsibilities: text(row.responsibilities),
    })),
    current_salary: Number(form.current_salary),
    expected_salary: Number(form.expected_salary),
    currency: text(form.currency).toUpperCase(),
    notice_period: text(form.notice_period),
    available_from: form.available_from,
    preferred_location: text(form.preferred_location),
    references: form.references.filter((row) => Object.values(row).some((value) => text(value))).map((row) => ({
      name: text(row.name),
      relationship: text(row.relationship),
      phone: normalizeInternationalPhone(row.phone),
    })),
    ...(photo ? { photo } : {}),
    signature,
    consent: true,
  };
}

export function toLocalDateTimeInput(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const pad = (number) => String(number).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function localDateInputValue(value = new Date()) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const pad = (number) => String(number).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function applicationImageSrc(image) {
  if (typeof image === "string") {
    const match = image.match(/^data:(image\/(?:png|jpeg));base64,([A-Za-z0-9+/]+={0,2})$/);
    return match ? image : null;
  }
  if (!image || typeof image !== "object") return null;
  const contentType = image.content_type;
  const data = image.data;
  if (!["image/png", "image/jpeg"].includes(contentType) || typeof data !== "string" || !/^[A-Za-z0-9+/]*={0,2}$/.test(data) || !data) return null;
  return `data:${contentType};base64,${data}`;
}